import {css} from 'styled-components';

import {ReactNode} from 'react';

import {VEHICLE_ALBUM_IMAGE_SIZE} from './utils';

interface VehicleAlbumImageGridProps {
  children: ReactNode;
}

export function VehicleAlbumImageGrid(props: VehicleAlbumImageGridProps) {
  return (
    <div
      css={css`
        display: grid;
        grid-template-columns: repeat(
          auto-fill,
          minmax(${({theme}) => theme.getSize(VEHICLE_ALBUM_IMAGE_SIZE.width)}, 1fr)
        );
        width: 100%;
        min-height: ${({theme}) => theme.getSize(VEHICLE_ALBUM_IMAGE_SIZE.height)};
        grid-gap: ${({theme}) => theme.getSize(3)};
      `}
    >
      {props.children}
    </div>
  );
}
